import Tile from "./engine/tile";

const CaveDescription = "The floor of the cave is worn smooth by seeping water and the footsteps of scurrying creatures.";
const Rock1Description = "Sheets of variegated flowstone stretch into the darkness.";
const Rock2Description = "The walls of the cave are draped with spectacular mineral formations.";
const Rock3Description = "Clusters of stalagmites and stalactites create a vaulted cavernous space.";
const Rock4Description = "The ribbons and folds of rock look like frozen waterfalls.";
const EntranceDescription = "";
const ExitDescription = "";

const Tiles = {
  CandleForYourFather: Tile.scenery("CandleForYourFather", "Many days and nights have passed since your father went into the caves to vanquish a stone giant and prevent its evil from settling on the land. Now the last candle has burned down and he has not returned."),
  Emblem: Tile.scenery("Emblem", "Слава Україні!"),
  Chimney: Tile.scenery("Chimney", "The old stone fireplace is built into the wall of the cottage."),
  Wall: Tile.scenery("Wall", "The wall of the farmhouse."),
  Field1: Tile.land("Field1", "Weedy grasses cover the fields."),
  Field2: Tile.land("Field1", "Thistles, clover and milkweeds dot the fields."),
  Field3: Tile.land("Field1", "The late-summer sun has burned these grasses dry."),
  Swale: Tile.land("Swale", "The field is swampy and sodden here."),
  Trees1: Tile.scenery("Trees1", "Dense thickets of scrub and small trees block the way."),
  Trees2: Tile.scenery("Trees2", "Dense thickets of scrub and small trees block the way."),
  Trees3: Tile.scenery("Trees3", "Dense thickets of scrub and small trees block the way."),
  Fence: Tile.scenery("Fence", "It’s supposed to keep the sheep out."),
  Furrow: Tile.land("Furrow", "A ploughed field where you grow your crops."),
  Cabbages: Tile.land("Cabbages", "The sheep like to escape their field to come in and eat these cabbages."),
  House: Tile.terrain("House", "It’s your home."),
  Floor: Tile.land("Floor", "Rustic floorboards."),
  CottageDoor: Tile.doorOpen("CottageDoor", "Bright green door painted in the traditional style of the valley here.", "ClosedCottageDoor"),
  ClosedCottageDoor: Tile.doorClosed("ClosedCottageDoor", "Bright green door painted in the traditional style of the valley here.", "CottageDoor"),

  ForestPath: Tile.portal("ForestPath", "An overgrown path leads deep into the forest...", "Training"),

  Forest1: Tile.terrain("Forest1", "The trunks of gnarled old oaks are covered in moss."),
  Forest2: Tile.scenery("Forest2", "Stands of ash and linden rise into a raveled canopy."),

  // Dense thickets of scrub and small trees block the way.

  ForestFloor1: Tile.land("ForestFloor1", "A thick carpet of leaves covers the forest floor."),
  ForestFloor2: Tile.land("ForestFloor2", "A thick carpet of leaves covers the forest floor."),
  ForestFloor3: Tile.land("ForestFloor3", "A thick carpet of leaves covers the forest floor."),
  ForestFloor4: Tile.land("ForestFloor4", "A thick carpet of leaves covers the forest floor."),
  ForestFloor5: Tile.land("ForestFloor5", "A thick carpet of leaves covers the forest floor."),
  ForestFloor6: Tile.land("ForestFloor6", "A thick carpet of leaves covers the forest floor."),

  ForestEntrance: Tile.emptyPortal("ForestEntrance", "Home is somewhere back that way."),
  ForestExit: Tile.emptyPortal("ForestExit", "The path leads up into the mountains."),

  Chasm: Tile.scenery("Chasm", "The shaft of the vast chasm extends deep underground."),

  CarbonateCave: Tile.land("CarbonateCave", CaveDescription),
  CarbonateRock1: Tile.terrain("CarbonateRock1", Rock1Description),
  CarbonateRock2: Tile.terrain("CarbonateRock2", Rock2Description),
  CarbonateRock3: Tile.terrain("CarbonateRock3", Rock3Description),
  CarbonateRock4: Tile.terrain("CarbonateRock4", Rock4Description),
  CarbonateEntrance: Tile.emptyPortal("CarbonateEntrance", EntranceDescription),
  CarbonateExit: Tile.emptyPortal("CarbonateExit", ExitDescription),

  SlateCave: Tile.land("SlateCave", CaveDescription),
  SlateRock1: Tile.terrain("SlateRock1", Rock4Description),
  SlateRock2: Tile.terrain("SlateRock2", Rock1Description),
  SlateRock3: Tile.terrain("SlateRock3", Rock2Description),
  SlateRock4: Tile.terrain("SlateRock4", Rock3Description),
  SlateEntrance: Tile.emptyPortal("SlateEntrance", EntranceDescription),
  SlateExit: Tile.emptyPortal("SlateExit", ExitDescription),

  LimestoneCave: Tile.land("LimestoneCave", CaveDescription),
  LimestoneRock1: Tile.terrain("LimestoneRock1", Rock2Description),
  LimestoneRock2: Tile.terrain("LimestoneRock2", Rock3Description),
  LimestoneRock3: Tile.terrain("LimestoneRock3", Rock4Description),
  LimestoneRock4: Tile.terrain("LimestoneRock4", Rock1Description),
  LimestoneEntrance: Tile.emptyPortal("LimestoneEntrance", EntranceDescription),
  LimestoneExit: Tile.emptyPortal("LimestoneExit", ExitDescription),

  DungeonFlagstone: Tile.land("DungeonFlagstone", "Marble flagstones riven with cracks and gouges."),
  RuinedWall1: Tile.terrain("RuinedWall1", "A crumbling wall piled with limbs of broken statues and monstrous stone skulls."),
  RuinedWall2: Tile.terrain("RuinedWall2", "A crumbling wall piled with limbs of broken statues and monstrous stone skulls."),
  RuinedWall3: Tile.terrain("RuinedWall3", "A crumbling wall piled with limbs of broken statues and monstrous stone skulls."),
  RuinedWall4: Tile.terrain("RuinedWall4", "A crumbling wall piled with limbs of broken statues and monstrous stone skulls."),

  KoboldStatue: Tile.scenery("KoboldStatue", "An impish little kobold frozen in milky stone."),
  BardStatue: Tile.scenery("BardStatue", "A petrified bard with a terrified expression on her marbled face."),
  AdventurerStatue: Tile.scenery("AdventurerStatue", "An adventurer stands stoic in smooth marble."),
  PaladinStatue: Tile.scenery("PaladinStatue", "A stone paladin with sword upraised."),
  OrcStatue: Tile.scenery("OrcStatue", "A huge orc chieftan, iced in mid-step."),
  TrollStatue: Tile.scenery("TrollStatue", "A lumbering stone troll stands silent."),
  YourFather: Tile.scenery("YourFather", "It’s your father! He’s frozen in stone, still glowing with the pallid aura of the petrifying magic."),

  BanquetTable: Tile.scenery("BanquetTable", "At the center of the ruined chamber, a table is laid with a sumptuous banquet."),

  PoolOfTears: Tile.land("PoolOfTears", "The surface of the dark pool is eerily still.")
}

const TileIndex = Object.keys(Tiles);

Tiles.get = function(index) {
  return Tiles[TileIndex[index]];
}

export default Tiles;
